module.exports = __webpack_public_path__ + "img/WEB-TOP-EROVET.82e6f66e.png";